/**
 * Created by zhouxuwang on 2021/12/10
 */

export default function filterSchemaHandle (props) {
  return {
    _type: 'tabs',
    viewComponentName: 'tabs-render',
    props: props.name
    // apiName
  }
}

export const filterProps = {
  // 是否需要重置
  isNeedReset: {
    type: Boolean,
    default: false
  },
  // 是否显示上边框
  showTopBorder: {
    type: Boolean,
    default: false
  },
  // 是否隐藏边框
  hideBorder: {
    type: Boolean,
    default: false
  }
}
